import GameEngine from './engine/GameEngine.js';
import OnboardingManager from './engine/OnboardingManager.js';
import { mountPixelBlob, unmountPixelBlob } from './pixelblobBridge.js';

window.addEventListener('DOMContentLoaded', () => {
    const game = new GameEngine();
    game.init();
    
    // Initialize Onboarding
    const onboarding = new OnboardingManager(game);
    onboarding.init();
    
    // Global access for debugging
    window.game = game;
    window.onboarding = onboarding;
    window.PixelBlobBridge = { mountPixelBlob, unmountPixelBlob };

    // Hide startup loader once i18n has been applied and first frame queued.
    requestAnimationFrame(() => {
        document.body.classList.remove('app-loading');
    });
});
